<template>
	<div class="sidebar-limit">
		<div class="sidebar-scroll-container">
			<div class="sidebar-main">
				<a href="https://www.landui.com/" target="_blank" class="logo"><span></span>蓝队云用户中心</a>
				<div class="head">
					<div class="user">88888<el-button size="small" type="danger" @click="exitClick">退出登录</el-button></div>
				</div>
				<div class="menu-block" v-bind:class="{ open: menuFoldStatus1 }">
					<div class="menu" @click="menuFoldClick(1)">
						<p><span>账号管理</span><i></i></p>
					</div>
					<ul class="sub-menu">
						<li>
							<router-link to="/account"><p><span>账户设置</span></p></router-link>
						</li>
						<li>
							<router-link to="/account/info"><p><span>基本资料</span></p></router-link>
						</li>
						<li>
							<router-link to="/account/pwd"><p><span>修改密码</span></p></router-link>
						</li>
						<li>
							<router-link to="/account/message"><p><span>站内信管理</span></p></router-link>
						</li>
						<li>
							<router-link to="/account/log"><p><span>日志管理</span></p></router-link>
						</li>
						<li>
							<router-link to="/account/notice"><p><span>通知设置</span></p></router-link>
						</li>
						<li>
							<router-link to="/verify"><p><span>实名认证</span></p></router-link>
						</li>
						<li>
							<router-link to="/account/address"><p><span>地址管理</span></p></router-link>
						</li>
					</ul>
				</div>
				<div class="menu-block" v-bind:class="{ open: menuFoldStatus2 }">
					<div class="menu" @click="menuFoldClick(2)">
						<p><span>财务管理</span><i></i></p>
					</div>
					<ul class="sub-menu">
						<li>
							<router-link to="/financial/pay"><p><span>充值中心</span></p></router-link>
						</li>
						<li>
							<router-link to="/order"><p><span>订单管理</span></p></router-link>
						</li>
						<li>
							<router-link to="/financial"><p><span>收支明细</span></p></router-link>
						</li>
						<li>
							<router-link to="/financial/cash"><p><span>代金券明细</span></p></router-link>
						</li>
						<li>
							<router-link to="/invoice"><p><span>发票管理</span></p></router-link>
						</li>
						<li>
							<router-link to="/refund"><p><span>退款管理</span></p></router-link>
						</li>
						<li>
							<router-link to="/financial/coupon"><p><span>优惠券管理</span></p></router-link>
						</li>
						<li>
							<router-link to="/financial/out"><p><span>财务转出</span></p></router-link>
						</li>
						<li>
							<router-link to="/financial/arrearlog"><p><span>欠费记录</span></p></router-link>
						</li>
					</ul>
				</div>
			</div>  
		</div>
	</div>
	<div class="copyright">
		Copyright © 2012 - {{ currentYear }} LanDui.com. All RightsReserved. 蓝队云 版权所有
		<a href="http://beian.miit.gov.cn/" target="_blank">工信部备案号 滇ICP备05000110号-1</a>
	</div>
</template>

<script setup>
		import { ref } from 'vue'
		import { useRouter } from 'vue-router'
		import { useStore } from 'vuex'
		import { ElMessage } from 'element-plus'
		import { apiExit } from '@/api/home'
		
		const store = useStore()
		const router = useRouter()
		const TOKEN = store.state.TOKEN
		const menuFoldStatus1 = ref('false')
		const menuFoldStatus2 = ref('false')
		const currentYear = ref(new Date().getFullYear());
		
		const menuFoldClick = (e) => {
			switch(e)
			{
				case 1:
					menuFoldStatus1.value = !menuFoldStatus1.value
				break;
				case 2:
					menuFoldStatus2.value = !menuFoldStatus2.value
				break;
			}
		}
</script>

<style scoped>
	.sidebar-main .logo{ 
		display: block;
		background-color: #000;
		text-align: center;
		padding: 16px 0;
		font-size: 17px;
		color: #fff;
		overflow: hidden;
	}
	.sidebar-main .logo span{
		display: block;
		height:35px;
		margin-bottom: 6px;
		background: url(../assets/images/logo_ico.png) center no-repeat;
		background-size: contain;
	}
	.copyright{position: fixed;background-color: #fff; text-align: center; border-top: 1px solid #ddd; left: 180px;right: 0;bottom: 0; z-index: 5; padding: 10px; line-height: 20px;overflow: hidden;}
	.copyright a{ margin-left: 15px; color: #555; padding-left: 20px; background: url(https://static.landui.com/statics/images/public/foot-logo1.png) left center no-repeat;}
	.copyright a:hover{color: #00aaff;}
</style>
